import { IAuthProvider, AuthUser, AuthResult, UserProfile, SignUpResult } from "../../types";

// Implement with aws-amplify or @aws-sdk/client-cognito-identity-provider when migrating.
// Required env vars:
//   REACT_APP_AWS_USER_POOL_ID
//   REACT_APP_AWS_USER_POOL_CLIENT_ID
//   REACT_APP_AWS_REGION
class AwsAuthProvider implements IAuthProvider {
  async signIn(_email: string, _password: string): Promise<AuthResult> {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  async signOut(): Promise<void> {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  async signUp(_email: string, _password: string): Promise<SignUpResult> {
    throw new Error("AwsAuthProvider.signUp is not implemented yet.");
  }

  async signInWithCustomToken(
    _token: string,
    _tenantId?: string | null,
  ): Promise<AuthResult> {
    throw new Error("AwsAuthProvider.signInWithCustomToken is not implemented yet.");
  }

  async sendPasswordReset(_email: string, _continueUrl?: string): Promise<void> {
    throw new Error("AwsAuthProvider.sendPasswordReset is not implemented yet.");
  }

  async reauthenticate(_currentPassword: string): Promise<void> {
    throw new Error("AwsAuthProvider.reauthenticate is not implemented yet.");
  }

  async setPassword(_password: string): Promise<void> {
    throw new Error("AwsAuthProvider.setPassword is not implemented yet.");
  }

  getCurrentUser(): AuthUser | null {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  onAuthStateChanged(_callback: (user: AuthUser | null) => void): () => void {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  async getEmailByCardNumber(_cardNumber: string): Promise<string | null> {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  async getUserProfile(_uid: string): Promise<UserProfile> {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  async getMustChangePassword(_uid: string): Promise<boolean> {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  async changePassword(_newPassword: string): Promise<void> {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }

  async getToken(): Promise<string | null> {
    throw new Error("AwsAuthProvider is not implemented yet.");
  }
}

export default AwsAuthProvider;
